// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".K08EA3bBXjrqrWcWiuFTDA\\=\\={display:flex}.K08EA3bBXjrqrWcWiuFTDA\\=\\= svg{margin-right:var(--xds-spacing-d)}", "",{"version":3,"sources":["webpack://./src/pages/Couriers/components/CourierQRCodeManager/components/QRCodeRegenerateContent/QRCodeRegenerateContent.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,gCACE,iCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileBottomSheetHeader": "K08EA3bBXjrqrWcWiuFTDA=="
};
export default ___CSS_LOADER_EXPORT___;
